import React from "react";
import { getAdjustedReferenceTime } from "utils/four-four-five-calendar-utils";
import { useCompanyTimezone } from "hooks/useTimezone";
import { getComponentRefTime } from "utils/time-utils";
import { CurrentDateDisplayProps } from "./CurentDateDisplayTypes";
import { getTextColor } from "../charts/utils";
import "./CurrentDateDisplay.scss";
import CurrentDate from "./CurrentDate";

export default function CurrentDateDisplay(props: CurrentDateDisplayProps) {
  const companyTz = useCompanyTimezone();
  const referenceTime = getAdjustedReferenceTime(
    getComponentRefTime(props),
    companyTz,
    props.calendarType,
    props.month?.showFinishedMonth,
    props?.showFinishedWeek
  );

  return (
    <div className="current-date-display-component" style={{ color: getTextColor(props.theme) }}>
      <CurrentDate
        timezone={companyTz}
        displayWeekOfYear={props.displayWeekOfYear}
        year={props.year}
        month={props.month}
        day={props.day}
        refTime={referenceTime}
      />
    </div>
  );
}
